import styles from './styles.module.scss'

const FormWrapper = ({
  title,
  children
}: {
  title: string
  children: React.ReactNode
}) => {
  return (
    <div className={styles.returnsForm__container}>
      <p className={styles.returnsForm__stepTitle}>{title}</p>
      {children}
    </div>
  )
}

export default FormWrapper
